export const P1_P2_TABS = {
    FEATURES: {
        TAB_1: [
            {
                key: 'p1_p2_cross_app_action',
                label: 'Seamless Action Across Apps',
                pc_image: '/s25/p1_p2/cross_app_action/pc.jpg',
                mo_image: '/s25/p1_p2/cross_app_action/mo.jpg'
            },
            {
                key: 'p1_p2_now_brief',
                label: 'Now Brief',
                pc_image: '/s25/p1_p2/now_brief/pc.jpg',
                mo_image: '/s25/p1_p2/now_brief/mo.jpg'
            },
            {
                key: 'p1_p2_circle_to_search',
                label: 'Circle to Search',
                pc_image: '/s25/p1_p2/circle_to_search/pc.jpg',
                mo_image: '/s25/p1_p2/circle_to_search/mo.jpg'
            },
            {
                key: 'p1_p2_audio_eraser',
                label: 'Audio Eraser',
                pc_image: '/s25/p1_p2/audio_eraser/pc.jpg',
                mo_image: '/s25/p1_p2/audio_eraser/mo.jpg'
            },
            {
                key: 'p1_p2_privacy',
                label: 'Privacy',
                pc_image: '/s25/p1_p2/privacy/pc.jpg',
                mo_image: '/s25/p1_p2/privacy/mo.jpg'
            }
        ],
        TAB_2: [
            // {
            //     key: 'p1_p2_pro_visual_engine',
            //     label: 'ProVisual Engine',
            //     pc_image: '/s25/p1_p2/pro_visual_engine/pc.jpg', // Hidden due to image unavailability
            //     mo_image: '/s25/p1_p2/pro_visual_engine/mo.jpg',
            // },
            {
                key: 'p1_p2_portrait',
                label: 'Portrait',
                pc_image: '/s25/p1_p2/portrait/pc.jpg',
                mo_image: '/s25/p1_p2/portrait/mo.jpg'
            },
            {
                key: 'p1_p2_nightography',
                label: 'Nightography Video',
                pc_image: '/s25/p1_p2/nightography/pc.jpg',
                mo_image: '/s25/p1_p2/nightography/mo.jpg'
            },
            {
                key: 'p1_p2_filters',
                label: 'Filters',
                pc_image: '/s25/p1_p2/filters/pc.jpg',
                mo_image: '/s25/p1_p2/filters/mo.jpg'
            },
            {
                key: 'p1_p2_auto_trim',
                label: 'Auto Trim',
                pc_image: '/s25/p1_p2/auto_trim/pc.jpg',
                mo_image: '/s25/p1_p2/auto_trim/mo.jpg'
            }
        ],
        TAB_3: [
            {
                key: 'p1_p2_processor',
                label: 'Processor',
                pc_image_exynos: '/s25/p1_p2/processor_exynos/pc.jpg',
                mo_image_exynos: '/s25/p1_p2/processor_exynos/mo.jpg',
                pc_image_qualcomm: '/s25/p1_p2/processor_qualcomm/pc.jpg',
                mo_image_qualcomm: '/s25/p1_p2/processor_qualcomm/mo.jpg'
            },
            {
                key: 'p1_p2_display',
                label: 'Display',
                pc_image: '/s25/p1_p2/display/pc.jpg',
                mo_image: '/s25/p1_p2/display/mo.jpg'
            },
            {
                key: 'p1_p2_battery',
                label: 'Battery',
                pc_image: '/s25/p1_p2/battery/pc.jpg',
                mo_image: '/s25/p1_p2/battery/mo.jpg'
            },
            // {
            //     key: 'p1_p2_durability',
            //     label: 'Durability',
            //     pc_image: '/s25/p1_p2/durability/mo.jpg', // Hidden due to image unavailability
            //     mo_image: '/s25/p1_p2/durability/mo.jpg',
            // },
            {
                key: 'p1_p2_one_ui',
                label: 'One UI',
                pc_image: '/s25/p1_p2/one_ui/pc.jpg',
                mo_image: '/s25/p1_p2/one_ui/mo.jpg'
            }
        ]
    },
    DISCLAIMERS: [
        {
            key: 'p1_p2_disclaimer_1',
            label: 'Disclaimer 1/4',
            pc_image: '/s25/p1_p2/disclaimers/1/pc.jpg',
            mo_image: '/s25/p1_p2/disclaimers/1/mo.jpg'
        },
        {
            key: 'p1_p2_disclaimer_2',
            label: 'Disclaimer 2/4',
            pc_image: '/s25/p1_p2/disclaimers/2/pc.jpg',
            mo_image: '/s25/p1_p2/disclaimers/2/mo.jpg'
        },
        {
            key: 'p1_p2_disclaimer_3',
            label: 'Disclaimer 3/4',
            pc_image: '/s25/p1_p2/disclaimers/3/pc.jpg',
            mo_image: '/s25/p1_p2/disclaimers/3/mo.jpg'
        },
        {
            key: 'p1_p2_disclaimer_4',
            label: 'Disclaimer 4/4',
            pc_image: '/s25/p1_p2/disclaimers/4/pc.jpg',
            mo_image: '/s25/p1_p2/disclaimers/4/mo.jpg'
        }
    ]
};

export const P3_TABS = {
    FEATURES: {
        TAB_1: [
            {
                key: 'p3_cross_app_action',
                label: 'Seamless Action Across Apps',
                pc_image: '/s25/p3/cross_app_action/pc.jpg',
                mo_image: '/s25/p3/cross_app_action/mo.jpg'
            },
            {
                key: 'p3_now_brief',
                label: 'Now Brief',
                pc_image: '/s25/p3/now_brief/pc.jpg',
                mo_image: '/s25/p3/now_brief/mo.jpg'
            },
            {
                key: 'p3_circle_to_search',
                label: 'Circle to Search',
                pc_image: '/s25/p3/circle_to_search/pc.jpg',
                mo_image: '/s25/p3/circle_to_search/mo.jpg'
            },
            {
                key: 'p3_audio_eraser',
                label: 'Audio Eraser',
                pc_image: '/s25/p3/audio_eraser/pc.jpg',
                mo_image: '/s25/p3/audio_eraser/mo.jpg'
            },
            {
                key: 'p3_privacy',
                label: 'Privacy',
                pc_image: '/s25/p3/privacy/pc.jpg',
                mo_image: '/s25/p3/privacy/mo.jpg'
            }
        ],
        TAB_2: [
            {
                key: 'p3_pro_visual_engine',
                label: 'ProVisual Engine',
                pc_image: '/s25/p3/pro_visual_engine/pc.jpg',
                mo_image: '/s25/p3/pro_visual_engine/mo.jpg'
            },
            {
                key: 'p3_portrait',
                label: 'Portrait',
                pc_image: '/s25/p3/portrait/pc.jpg',
                mo_image: '/s25/p3/portrait/mo.jpg'
            },
            {
                key: 'p3_nightography_video',
                label: 'Nightography Video',
                pc_image: '/s25/p3/nightography/pc.jpg',
                mo_image: '/s25/p3/nightography/mo.jpg'
            },
            {
                key: 'p3_high_resolution',
                label: 'High Resolution',
                pc_image: '/s25/p3/high_resolution/pc.jpg',
                mo_image: '/s25/p3/high_resolution/mo.jpg'
            }
        ],
        TAB_3: [
            {
                key: 'p3_processor',
                label: 'Processor',
                pc_image: '/s25/p3/processor/pc.jpg',
                mo_image: '/s25/p3/processor/mo.jpg'
            },
            {
                key: 'p3_display',
                label: 'Display',
                pc_image: '/s25/p3/display/pc.jpg',
                mo_image: '/s25/p3/display/mo.jpg'
            },
            {
                key: 'p3_battery',
                label: 'Battery',
                pc_image: '/s25/p3/battery/pc.jpg',
                mo_image: '/s25/p3/battery/mo.jpg'
            },
            {
                key: 'p3_durability',
                label: 'Durability',
                pc_image: '/s25/p3/durability/pc.jpg',
                mo_image: '/s25/p3/durability/mo.jpg'
            },
            {
                key: 'p3_one_ui',
                label: 'One UI',
                pc_image: '/s25/p3/one_ui/pc.jpg',
                mo_image: '/s25/p3/one_ui/mo.jpg'
            }
        ]
    },
    DISCLAIMERS: [
        {
            key: 'p3_disclaimer_1',
            label: 'Disclaimer 1/4',
            pc_image: '/s25/p3/disclaimers/1/pc.jpg',
            mo_image: '/s25/p3/disclaimers/1/mo.jpg'
        },
        {
            key: 'p3_disclaimer_2',
            label: 'Disclaimer 2/4',
            pc_image: '/s25/p3/disclaimers/2/pc.jpg',
            mo_image: '/s25/p3/disclaimers/2/mo.jpg'
        },
        {
            key: 'p3_disclaimer_3',
            label: 'Disclaimer 3/4',
            pc_image: '/s25/p3/disclaimers/3/pc.jpg',
            mo_image: '/s25/p3/disclaimers/3/mo.jpg'
        },
        {
            key: 'p3_disclaimer_4',
            label: 'Disclaimer 4/4',
            pc_image: '/s25/p3/disclaimers/4/pc.jpg',
            mo_image: '/s25/p3/disclaimers/4/mo.jpg'
        }
    ]
};
